<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/xuanhe" />
          <div class="Solutions">
            <img style="margin: 20px 0 200px 0;max-width: 100%" :src="baseApi+ 'upload/product/anli1.jpg'">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/classics/componets/Banner'
import Tab from '@/views/classics/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/classics/xuanhe.vue